export default function initM23() {
   const $ = jQuery
$(document).ready(function() {

   new $.Zebra_Accordion('#Zebra_Accordion1');


});
}